import { render, staticRenderFns } from "./PinDetail.vue?vue&type=template&id=58828630&"
import script from "./PinDetail.vue?vue&type=script&lang=js&"
export * from "./PinDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports